// The one admin-wide vocabulary for booking-status copy (Leon, 2026-09-23) —
// Dispatch, Bookings and Live Map render the SAME words for the same status
// rather than each screen inventing its own. Picked to read from the rider's
// job, not the raw enum: a rider "dropping off" the therapist is done exactly
// when the booking flips to `arrived` — Confirm Drop-Off closes his trip at
// that instant (0237) — and `in_session`/`completed` read as "Ongoing
// service"/"Complete" everywhere instead of the enum's own spelling.
//
// Single source so the three surfaces cannot drift the way `STATUS_STYLES`
// and `CHIP_ORDER` already duplicate the raw enum in three files each with
// their own `.replace(/_/g, " ")` — this does not touch those (they are
// filter/style keys, not reader-facing copy), only the actual status TEXT.

import type { Enums } from "@bednbody/types/database";

export const BOOKING_STATUS_LABEL: Record<Enums<"booking_status">, string> = {
  pending: "Pending",
  awaiting_therapist: "Awaiting therapist",
  awaiting_rider: "Awaiting rider",
  dispatched: "Picking up therapist",
  en_route_to_client: "Dropping off therapist",
  arrived: "Drop-off complete",
  in_session: "Ongoing service",
  completed: "Complete",
  cancelled: "Cancelled",
};

/** Falls back to the raw enum, spaced out, for any status this map misses. */
export function bookingStatusLabel(status: string): string {
  return (BOOKING_STATUS_LABEL as Record<string, string>)[status] ?? status.replace(/_/g, " ");
}
